import React, { type ReactNode } from 'react';
import AuthGuard from './AuthGuard';
import GuestGuard from './GuestGuard';

type GuardProps = {
  authGuard: boolean;
  guestGuard: boolean;
  children: ReactNode;
};

const Guard = (props: GuardProps) => {
  const { authGuard, guestGuard, children } = props;

  if (guestGuard) {
    return <GuestGuard>{children}</GuestGuard>;
  } else if (!guestGuard && !authGuard) {
    return <>{children}</>;
  } else {
    return <AuthGuard>{children}</AuthGuard>;
  }
};

export default Guard;
